export default __webpack_public_path__ + "static/media/CSS_Logo_3_zeilig_Farbe.582e14f1.svg";